<div #toastBox fxLayout="row" fxLayoutAlign=" center" fxFlex fxLayoutGap="20px">
    <div fxHide fxShow.gt-sm *ngIf="toastPackage.toastType == 'toast-error'">
        <mat-icon class="fc-white ic-36">error</mat-icon>
    </div>
    @if (options.enableHtml) {
        <div #messageContainer class="toast-msg" fxFlex [innerHTML]="message"></div>
    } @else {
        <div class="toast-msg" fxFlex>{{message}}</div>
    }
    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
        <div class="copy-container" *ngIf="toastPackage.toastType == 'toast-error'">
            <div class="copy-tooltip" [ngClass]="{ 'active': toggleTooltip }">
                <div class="mat-tooltip">{{ 'toast.copy.success' | translate}}</div>
            </div>
            <a class="icon-copy" ngxClipboard [cbContent]="copyContent"
                (click)="copy($event)" (mouseenter)="toggleTooltip = true" (mouseleave)="toggleTooltip = false" >
                <mat-icon class="ic-svg-white fc-white" svgIcon="icon_copy"></mat-icon>
                <mat-icon *ngIf="copied" class="success">check_circle</mat-icon>
            </a>
        </div>
        <a class="icon-close" fxLayout="row" fxLayoutAlign="center center">
            <mat-icon class="ic-32 fc-white">close</mat-icon>
        </a>
    </div>
</div>
